exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sptable>tr>td[data-v-5440a600]{height:20px;padding:5px;border-top:0}.font-500[data-v-5440a600],.font-700[data-v-5440a600]{font-weight:700}#EditViewModal .modal-dialog[data-v-5440a600],#VendorInfoModal .modal-dialog[data-v-5440a600]{min-width:80%}", ""]);

// exports
